import { CustomBoxV2 } from "components";
import { ActiveUserIcon } from "pages/internal-dashboard/icons";

export function ActiveUsers({ data, loading }: any) {
  return (
    <CustomBoxV2
      color="#006AB3"
      title="Active Users"
      userCount={data?.total?.count || 0}
      boxData={{
        label: "Active Users",
        todayCount: data?.today?.count || 0,
        weekCount: data?.thisWeek?.count || 0,
        monthCount: data?.thisMonth?.count || 0,
        yearCount: data?.thisYear?.count || 0,
        icon: ActiveUserIcon,
      }}
      percentages={{
        day: data?.today?.growth || 0,
        month: data?.month?.growth || 0,
        week: data?.week?.growth || 0,
        year: data?.year?.growth || 0,
      }}
      loading={loading}
    />
  );
}
